import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=f02bb572"
import script from "./MessageHeader.vue?vue&type=script&lang=js"
export * from "./MessageHeader.vue?vue&type=script&lang=js"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=f02bb572&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports